/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

import React from "react";
import PropTypes from "prop-types";
import "./Why.css";

// Card data for better maintainability
const cardData = {
  left: [
    {
      icon: "bi-laptop",
      title: "VISIT OUR GALLERY",
      text: "Start your journey by exploring our curated digital art gallery.",
    },
    {
      icon: "bi-heart",
      title: "MARK FAVORITES",
      text: "Save your favorite pieces and return to them anytime.",
    },
    {
      icon: "bi-eye",
      title: "DISCOVER DIGITAL ART",
      text: "Explore unique digital artworks from talented creators.",
    },
  ],
  right: [
    {
      icon: "bi-palette",
      title: "APPRECIATE ARTISTRY",
      text: "Connect with the creative vision behind each piece.",
    },
    {
      icon: "bi-collection",
      title: "CURATED COLLECTIONS",
      text: "Discover carefully selected artworks across various themes.",
    },
    {
      icon: "bi-stars",
      title: "ENJOY THE EXPERIENCE",
      text: "Immerse yourself in our curated digital art experience.",
    },
  ],
};

// Reusable card component
const FeatureCard = ({ icon, title, text }) => (
  <div className="modern-card">
    <div className="card-icon">
      <i className={`bi ${icon}`}></i>
    </div>
    <div className="card-content">
      <h3 className="card-title">{title}</h3>
      <p className="card-text">{text}</p>
    </div>
  </div>
);

FeatureCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default function Why() {
  return (
    <section className="why">
      <div className="container-fluid">
        <div className="content">
          <h2>
            <span>WHY CHOOSE US?</span>
          </h2>
          <div className="row">
            <div className="col-md-4">
              {cardData.left.map((card, index) => (
                <FeatureCard key={`left-${card.title}-${index}`} {...card} />
              ))}
            </div>
            <div className="col-md-4">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <img className="img-fluid center-img" src={require("../images/Knight.png")} alt="center-img" />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              {cardData.right.map((card, index) => (
                <FeatureCard key={`right-${card.title}-${index}`} {...card} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
